export interface Day {
  day: number;
  hours: Array<Hour>;
}

export interface Hour {
  hour: number;
  expected: number;
  actual: number;
  predict: boolean;
}

export class Days {
  days: Day[];
  constructor(days: Array<Day>) {
    this.days = days;
  }

  getAllHours() {
    const extractAllHours: Array<Hour> = [];
    for (let index = 0; index < this.days.length; index++) {
      const day = this.days[index];
      for (let index = 0; index < day.hours.length; index++) {
        const hour = day.hours[index];
        extractAllHours.push(hour);
      }
    }
    return extractAllHours;
  }

  getHour(index: number): Hour {
    let sum = 0;
    for (let indexDois = 0; indexDois < this.days.length; indexDois++) {
      const day = this.days[indexDois];
      for (let indexTres = 0; indexTres < day.hours.length; indexTres++) {
        const hour = day.hours[indexTres];
        if (sum == index) {
          return hour;
        }
        sum++;
      }
    }
    return this.days[0].hours[0];
  }

  getDay(index: number): Day {
    let sum = 0;
    for (let indexDois = 0; indexDois < this.days.length; indexDois++) {
      const day = this.days[indexDois];
      for (let indexTres = 0; indexTres < day.hours.length; indexTres++) {
        if (sum == index) {
          return day;
        }
        sum++;
      }
    }
    return {
      day: -1,
      hours: [],
    };
  }
}
